<template>
  <ListConfigPanel
    :items="publications"
    id-key="publication_id"
    :currently-selected-id="currentlySelectedPublicationId"
    icon="fluent:document-one-page-multiple-20-regular"
    :get-label="p => p.name"
    empty-text="No Publications"
    @select:item="$emit('select:publication', $event)"
  />
</template>

<script>

import ListConfigPanel from "@/components/create-dashboard/ListConfigPanel.vue";

export default {
  name: "PublicationsConfigPanel",
  components: { ListConfigPanel },
  props: {
    publications: {
      type: Array,
      required: false,
      default: () => [],
    },
    currentlySelectedPublicationId: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  emits: ["select:publication"],
};
</script>
